export default __webpack_public_path__ + "images/4ff71861cad7fdeaaa37f78df9eb8e90-halloween_seasonal_tablet.webp";